<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>
            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <!-- render the view button only if the user's permissions allow it -->
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: {
        //type, // not used

        /**
         * List of items to  be displayed in the table
         */
        items: Array,
        /**
         * The title of the table
         */
        title: String,
    },

    data() {
        return {
            query: '',
            page: 1,
            fields: [{ key: 'id', label: 'Actions' }, 'name'],
        }
    },

    mounted() {},

    methods: {
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `Are you sure you want to delete ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('requestCategory/delete', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Your Item has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete item!',
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
